export class PaginationModel {
	pageIndex: number = 0;
	pageSize: number = 5;
	startElement: number = 0;
	lastElement: number;
	filter: any[];
    total: any[];
	constructor(
		pageIndex:number,
		pageSize:number,
		startElement:number,
		lastElement:number,
		filter,
		total
	){
		this.pageIndex = pageIndex;
		this.pageSize = pageSize;
		this.startElement = startElement;
		this.lastElement = lastElement;
		this.filter = filter;
		this.total = total;
	}
}

export class SimplePaginationModel {
	page: number = 0;
	size: number = 5;
	start: number = 0;
	end: number;
    total: number;
	constructor(
		page:number,
		size:number,
		start:number,
		end:number,
		total
	){
		this.page = page;
		this.size = size;
		this.start = start;
		this.end = end;
		this.total = total;
	}
}